import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { useAuth } from './hooks/useAuth'
import FormPage from './pages/FormPage'
import SubmitSuccessPage from './pages/SubmitSuccessPage'
import TrackPage from './pages/TrackPage'
import BulkImportPage from './pages/BulkImportPage'
import AdminLoginPage from './pages/AdminLoginPage'
import CaseDetailPage from './pages/CaseDetailPage'
import RegionPage from './pages/RegionPage'
import RegionManagerPage from './pages/RegionManagerPage'
import AdminLayout from './components/admin/AdminLayout'
import Dashboard from './components/admin/Dashboard'
import CaseList from './components/admin/CaseList'
import SettingsPanel from './components/admin/SettingsPanel'
import UsersPanel from './components/admin/UsersPanel'
import OfflineBanner from './components/ui/OfflineBanner'

function ProtectedRoute({ children }) {
  const { token } = useAuth()
  if (!token) return <Navigate to="/admin/login" replace />
  return children
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <OfflineBanner />
        <Routes>
          {/* Public */}
          <Route path="/" element={<FormPage />} />
          <Route path="/success" element={<SubmitSuccessPage />} />
          <Route path="/track" element={<TrackPage />} />
          <Route path="/bulk" element={<BulkImportPage />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="cases" element={<CaseList />} />
            <Route path="cases/:id" element={<CaseDetailPage />} />
            <Route path="regions" element={<RegionManagerPage />} />
            <Route path="regions/:regionId" element={<RegionPage />} />
            <Route path="settings" element={<SettingsPanel />} />
            <Route path="users" element={<UsersPanel />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
